import { Injectable } from '@angular/core';
import { ApiEndPointType } from '@shared/enums/common';
import { AuthService } from '@services/auth.service';
import { HttpRepo } from '@shared/services/httprepo';
import { Observable } from 'rxjs';
import { CodeTypeModel } from '@fs/models/code-type.model';

@Injectable({
  providedIn: 'root'
})
export class DispatcherService {

  constructor(private auth: AuthService, private httpRepo: HttpRepo) {
    this.httpRepo.setAbsoluteUrl(this.auth.getCompanyId(), ApiEndPointType.FS);
  }

  // GET Dispatchboard data
  // Use now to get unassignedWorkOrder list
  public GetDispatchData(filters: any, isPeriodic = false, date: string = new Date().toString()) {
    if (isPeriodic != null && (isPeriodic)){
      return this.httpRepo.GetPeriodic("dispatchboard?filter=" + encodeURIComponent(JSON.stringify(filters)), date);
    }

    return this.httpRepo.Get("dispatchboard", "filter=" + encodeURIComponent(JSON.stringify(filters)));
  }

  // GET Dispatchboard data
  // Need to rename later when api changes are final
  // Use now to get Users list data only
  public GetDispatchData_New(filters: any, isPeriodic = false, date: string = new Date().toString()) {
    if (isPeriodic != null && (isPeriodic)) {
      return this.httpRepo.GetPeriodic("appointments?filter=" + encodeURIComponent(JSON.stringify(filters)), date);
    }

    //return this.httpRepo.Get("dispatchboard", "filter=" + encodeURIComponent(JSON.stringify(filters)));
    return this.httpRepo.Get("appointments", "filter=" + encodeURIComponent(JSON.stringify(filters)));
  }

  // POST // incase of dragging data
    public PostDispatchWorkOrder(data: any): Observable<any> {
    return this.httpRepo.Post("worktickets/" + data.ID + "/assignments/" + data.UserID, data);
  }

    // PUT // incase of dragging data
    public UpdateDispatchWorkOrder(data: any): Observable<any> {
      data.Id=data.ID;
      return this.httpRepo.Put("worktickets/" + data.ID + "/assignments/" + data.UserID, data);
    }

    public UpdateDispatchWorkOrder_Patch(data: any): Observable<any> {
      data.Priority=""; //fix for .NET Core
      data.ServiceType="";
      return this.httpRepo.Patch("customers/" + data.CustomerID + "/jobsites/" + data.JobSiteID + "/worktickets/" + data.ID, data);
    }
    // DELETE // incase of dragging data
    public DeleteDispatchWorkOrder(ID: any): Observable<any> {
      return this.httpRepo.Delete("worktickets/" + ID + "/assignments");
    }

    public Post_Dispatch_Appointment(data: any): Observable<any> {
      data.Id = data.ID;
      return this.httpRepo.Post("appointments", data);
    }

    public Put_Dispatch_Appointment(data: any): Observable<any> {
      return this.httpRepo.Put("appointments/"+data.ID, data);
    }

    public Delete_Dispatch_Appointment(ID: any): Observable<any> {
      return this.httpRepo.Delete("appointments/" + ID);
    }

    public UpdateDispatchEstimate_Patch(appointmentID: string, status: CodeTypeModel, subStatus: CodeTypeModel): Observable<any> {
      return this.httpRepo.Patch("appointments/" + appointmentID, { Status: status, SubStatus: subStatus });
    }
}
